import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Map from "./../../../Map";

import { ObjectFound, GetUserId, GetUserName } from "./../../js/Main";
import { SearchComponent } from "../search/SearchComponent";
import SideBar from "../sidebar/SideBarTest";

import { isMobile } from "react-device-detect";
import { useAuth } from "./../AuthContext";
import {
  BsFillGeoAltFill,
  BsGearFill,
  BsBoxArrowRight,
  BsEyeSlash,
  BsHeadset
} from "react-icons/bs";
import { Passport } from '../sidebar/Passport';

var isMobileVersion = isMobile;

function HomePage() {
  console.log(
    "process.env.REACT_APP_IS_MOBILE = " + process.env.REACT_APP_IS_MOBILE
  );
  if (!(process.env.REACT_APP_IS_MOBILE === "true")) {
    isMobileVersion = false;
  }

  const [isSidebar, setSidebar] = useState(false);
  const [isEditing, setUpdateSidebar] = useState(false);
  const [isCancelUpdateSidebar, setCancelUpdateSidebar] = useState(false);
  const [isSaveSidebar, setSaveSidebar] = useState(false);
  const [sidebarClosedByUser, setSidebarClosedByUser] = useState(true);
  const [isEditingSidebar, setIsEditingSidebar] = useState(false);
  const [lastTypecode, setTypecode] = useState(-1);
  const [lastId, setId] = useState(-1);
  const [lastName, setLastName] = useState("");
  const [paramcodeList, setparamcodeArray] = useState([]);
  const [paramvalueList, setparamvalueArray] = useState([]);

  const [isBottom, setIsBottom] = useState(false);
  const [isEditingBottomBar, setUpdateBottombar] = useState(false);
  const [isCancelUpdateBottombar, setCancelUpdateBottombar] = useState(false);
  const [isSaveBottombar, setSaveBottombar] = useState(false);
  const [linkdetpBottom, setLinkedtpBottom] = useState("");

  const updateValue = (code, value) => {
    let index = paramcodeList.indexOf(code);
    if (index === -1) {
      paramcodeList.push(code);
      paramvalueList.push(value);
    } else {
      paramvalueList.splice(index, 1, value);
    }
  };

  const ShowSideBar = (typecode, id, isEdit, name) => {
    const info_side = isMobileVersion ? '.info-side-mobile' : '.info-side';
    const container = document.querySelector(info_side);
    container.innerHTML = '';

    // Создаём div для React
    const passportContainer = document.createElement('div');
    passportContainer.style.height = '100%';
    passportContainer.style.overflowY = 'auto';
    container.appendChild(passportContainer);

    ReactDOM.render(
      <Passport
        id={id}
        typecode={typecode}
        name={name}
        isEdit={isEdit}
        onValueChange={(code, value) => {
          updateValue(code, value); // ← существующая функция
        }}
      />,
      passportContainer
    );
  };

  const toggleBottomMenu = (linkedtp) => {
    setLinkedtpBottom(linkedtp);
  };

  const toggleSidebar = (typecode, id, name, setOpen, setEdit) => {
    setTypecode(typecode);
    setId(id);
    setLastName(name);
    setIsEditingSidebar(false);

    console.log("setOpen = " + setOpen);
    if (setOpen) {
      setSidebar(true);
    }
    if (setEdit) {
      setUpdateSidebar(true);
      setCancelUpdateSidebar(false);
      ShowSideBar(typecode, id, true, name);
    } else {
      setUpdateSidebar(false);
      setCancelUpdateSidebar(false);

      ShowSideBar(typecode, id, false, name);
    }
  };

  const handleCloseSidebar = () => {
    setSidebar(!isSidebar);
    setSidebarClosedByUser(true);
  };

  const saveSideBar = () => {
    
    if (lastTypecode == 7 || lastTypecode == 8) {
      var link = `${process.env.REACT_APP_BASE_URL}/api/object_params/updateLineParams`
    }
    else {
      var link = `${process.env.REACT_APP_BASE_URL}/api/object_params/updateParams`
    }
    const apiUrl = link;
    const dataToSend = {
      object_id: lastId,
      paramcodeList: paramcodeList,
      paramvalueList: paramvalueList,
      userId: GetUserId(),
      username: GetUserName(),
      entityName: lastName 
    };
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => {
      if (!response.ok) {
        // Сервер ответил с ошибкой (4xx/5xx) — читаем тело и выбрасываем,
        // чтобы попасть в .catch ниже вместо ложного "успеха"
        return response.json().then((errData) => {
          throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
        });
      }
      return response.json();
    })
    .then((data) => {
      console.log("Response from server:", data);
      ShowSideBar(lastTypecode, lastId, false, lastName);
    })
    .catch((error) => {
      console.error("Error sending POST request:", error);
      alert(`Не удалось сохранить изменения: ${error.message}`); // ← сообщаем пользователю
    });
  };

  // useEffect будет вызываться каждый раз, когда isUpdateSidebar изменяется
  useEffect(() => {
    if (isEditing) {
      paramcodeList.splice(0, paramcodeList.length);
      paramvalueList.splice(0, paramvalueList.length);
      ShowSideBar(lastTypecode, lastId, true, lastName);
    }
    if (isCancelUpdateSidebar) {
      ShowSideBar(lastTypecode, lastId, false, lastName);
    }
    if (isSaveSidebar) {
      saveSideBar();
      setSaveSidebar(false);
    }
  }, [isEditing, isCancelUpdateSidebar, isSaveSidebar, isEditingBottomBar]);

  const { user } = useAuth();

  const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPPandTP?name=`;

  const mobilePanelBtn = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    borderRadius: '10px',
    border: '1px solid #e5e7eb',
    background: '#f9fafb',
    fontSize: '13px',
    fontWeight: 500,
    color: '#374151',
    cursor: 'pointer',
    flex: 1,
    justifyContent: 'center'
  };

  return (
    <div className="home__page">
      {
        <div className="sidebar__style">
          <SideBar
            isActive={isSidebar}
            setIsActive={handleCloseSidebar}
            setUpdateSidebar={setUpdateSidebar}
            setCancelUpdateSidebar={setCancelUpdateSidebar}
            setSaveSidebar={setSaveSidebar}
            isEditing={isEditing}
          ></SideBar>
        </div>
      }

      {!isMobileVersion ? (
        <div id="checkboxGroup">
          <legend>Настройки</legend>

          <input type="checkbox" id="ShowAllObjects" autocomplete="off" />
          <label for="ShowAllObjects">Показывать все опоры и линии</label>
          {<button id="showAllStat" class="simple_button">Статистика</button>}
          <button id="showSupport" class="simple_button">Поддержка</button>
          {/* Добавляем небольшое расстояние между кнопками */}
          <span style={{ marginRight: "5px" }}></span>
          <button id="logOut" class="simple_button">Выход</button>
        { /* <div>
            <button id="rotateBtn" class="simple_button">Повернуть карту на </button>
            <input type="text" style={{width: 50}} id="rotateDeg" />{" "}
          </div>*/}
        </div>
      ) : (
        <div id="checkboxMobileGroup">
  <legend>Настройки</legend>

  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
    <input type="checkbox" id="ShowAllObjects" autoComplete="off" 
      style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
    <label htmlFor="ShowAllObjects" style={{ fontSize: '14px', color: '#374151', cursor: 'pointer' }}>
      Показывать все опоры и линии
    </label>
  </div>

  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
    <button id="hidePanel" style={mobilePanelBtn}>
      <BsEyeSlash style={{ fontSize: '16px' }} />
      Скрыть
    </button>
    <button id="showAllStat" style={mobilePanelBtn}>
      Статистика
    </button>
    <button id="showSupport" style={mobilePanelBtn}>
  <BsHeadset style={{ fontSize: '16px' }} />
  Поддержка
</button>
    <button id="logOut" style={{ ...mobilePanelBtn, color: '#ef4444' }}>
      <BsBoxArrowRight style={{ fontSize: '16px' }} />
      Выход
    </button>
  </div>
</div>
      )}
      {!isMobileVersion ? (
        ""
      ) : (
        <button id="settingsButton" class="settings-button">
          <BsGearFill style={{ fontSize: '20px', color: '#374151' }} />
        </button>
      )}
      
      <button id="showUserLocation" class="location-button">
         <BsFillGeoAltFill style={{ fontSize: '20px', color: '#3b82f6' }} />
      </button>
      
      <div className="div__style">
        <SearchComponent
          handeleClickFind={ObjectFound}
          home={true}
          link={searchLink}
        ></SearchComponent>

      </div>

      <Map
        onMarkerClick={toggleSidebar}
        onBottomMarkerClick={toggleBottomMenu}
        onSideBar={setSidebar}
      />
      
    </div>
  );
}

export function TestFunction() {
  console.log("test function");
}

export { HomePage };